
///
/// EarthBrowser
///
/// Environment detection utilities
/// Copyright (c) 2025 Geodata Labs
///

/**
 * Determine if running in production environment
 * Works reliably in both standard Node.js and Cloudflare Workers
 */
export function isProduction(): boolean {

	// In server context, check NODE_ENV (works for local dev and traditional deployments)
	if (typeof process !== 'undefined' && process.env?.NODE_ENV) {
		return process.env.NODE_ENV === 'production'
	}

	// Default to production for safety
	return true
}

/**
 * Determine if running in development environment
 */
export function isDevelopment(): boolean {
	return !isProduction()
}

/**
 * Determine if running as a Tauri desktop application
 * Tauri apps expose a __TAURI__ global object
 */
export function isTauriApp(): boolean {
	return typeof window !== 'undefined' && '__TAURI__' in window
}
